import {createFileRoute} from '@tanstack/react-router';

import {CompanyProfile} from '@/features/User/components/Company/CompanyProfile';

export const Route = createFileRoute('/_b/_p/_company/company')({
  component: CompanyProfile,
});
